var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeabag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 7.5C7.75 4.87665 9.87665 2.75 12.5 2.75C15.1234 2.75 17.25 4.87665 17.25 7.5V15H16.618C16.2393 15 15.893 15.214 15.7236 15.5528L15 17V21C15 21.5523 15.4477 22 16 22H20C20.5523 22 21 21.5523 21 21V17L20.2764 15.5528C20.107 15.214 19.7607 15 19.382 15H18.75V7.5C18.75 4.04822 15.9518 1.25 12.5 1.25C9.04822 1.25 6.25 4.04822 6.25 7.5V8H4.53518C4.20083 8 3.8886 8.1671 3.70313 8.4453L2.16795 10.7481C2.05844 10.9123 2 11.1054 2 11.3028V20C2 21.1046 2.89543 22 4 22H10C11.1046 22 12 21.1046 12 20V11.3028C12 11.1054 11.9416 10.9123 11.8321 10.7481L10.2969 8.4453C10.1114 8.1671 9.79917 8 9.46482 8H7.75V7.5ZM6 10.25H8C8.41421 10.25 8.75 10.5858 8.75 11C8.75 11.4142 8.41421 11.75 8 11.75H6C5.58579 11.75 5.25 11.4142 5.25 11C5.25 10.5858 5.58579 10.25 6 10.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeabag);
export default __webpack_public_path__ + "static/media/teabag.79f729edc86a32c1fdcaa40ec9855bf0.svg";
export { ForwardRef as ReactComponent };